import { ReactComponent as Info } from '../../../../assets/Icons/lucideIcons/info.svg';
import { Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const HealthColumnHeader = ({ column }) => {
  return (
    <Box
      style={{ cursor: 'pointer' }}
      sx={{
        whiteSpace: 'noWrap',
        overflow: 'hidden',
        marginRight: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box component="div" title={column?.heading}>
        {column?.heading}
      </Box>
      <Tooltip title="Click on the circle to view alerts." placement="top">
        <Info width={16} height={16} />
      </Tooltip>
    </Box>
  );
};
HealthColumnHeader.propTypes = {
  column: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default HealthColumnHeader;
